import Link from '@commons/components/Link';

import type { IntelligenceNodeProps } from '.';

/**
 * Intelligence node component for the Label display type.
 */

const IntelligenceNodeLabel = ({ title, alias }: IntelligenceNodeProps) => {
  return <Link href={alias}>{title}</Link>;
};

export default IntelligenceNodeLabel;
